import { l as _inherits, h as _createClass, i as _classCallCheck, m as _callSuper } from './_rollupPluginBabelHelpers-e71b1aad.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import { B as Button } from './Button-a16585e5.js';
import { I as Icon } from './index-11bc5ac3.js';
import { R as ReactPortal } from './ReactPortal-f1f8cb85.js';
import { F as FormattedMessage } from './message-f222f616.js';

var FullScreenPopUp = /*#__PURE__*/function (_React$Component) {
  function FullScreenPopUp(props) {
    var _this;
    _classCallCheck(this, FullScreenPopUp);
    _this = _callSuper(this, FullScreenPopUp, [props]);
    _this.state = {
      isActive: false,
      modalTitle: props.title,
      modalContent: props.content,
      isDeepContent: false
    };
    _this.closePopUp = _this.closePopUp.bind(_this);
    _this.openPopUp = _this.openPopUp.bind(_this);
    _this.getTriggerElement = _this.getTriggerElement.bind(_this);
    _this.getButtonElements = _this.getButtonElements.bind(_this);
    _this.getPortal = _this.getPortal.bind(_this);
    _this.findDeepContent = _this.findDeepContent.bind(_this);
    _this.setModalInformation = _this.setModalInformation.bind(_this);
    _this.scrollToTop = _this.scrollToTop.bind(_this);
    _this.handleOnGoBack = _this.handleOnGoBack.bind(_this);
    _this.modalContentRef = React__default.createRef();
    return _this;
  }
  _inherits(FullScreenPopUp, _React$Component);
  return _createClass(FullScreenPopUp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        forceOpen = _this$props.forceOpen,
        deepContent = _this$props.deepContent;
      if (forceOpen) {
        this.openPopUp();
      }
      if (deepContent.length) {
        this.findDeepContent();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props2 = this.props,
        forceOpen = _this$props2.forceOpen,
        content = _this$props2.content;
      if (nextProps.forceOpen !== forceOpen && nextProps.forceOpen) {
        this.setState({
          isActive: nextProps.forceOpen
        });
        this.findDeepContent();
      }
      if (nextProps.content !== content) {
        this.setState({
          modalContent: nextProps.content
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var forceOpen = this.props.forceOpen;
      if (forceOpen) {
        this.closePopUp();
      }
      document.body.classList.remove('full-screen-modal-open');
    }
  }, {
    key: "getTriggerElement",
    value: function getTriggerElement() {
      var trigger = this.props.trigger;
      var onClick = this.openPopUp;
      var triggerElement = React__default.cloneElement(trigger, {
        onClick: onClick
      });
      this.findDeepContent();
      return triggerElement;
    }
  }, {
    key: "getButtonElements",
    value: function getButtonElements() {
      var _this2 = this;
      var buttons = this.props.buttons;
      var renderButtons = buttons.map(function (button, index) {
        var key = "FULLSCREENPOPUPBUTTON_".concat(index);
        var closeFullScreenPopUp = _this2.closePopUp;
        // Each button must contain onClick function
        var buttonOnClick = button.props.onClick;

        // Wrap onClick function of the element to send close function as parameter
        var onClick = function onClick() {
          buttonOnClick(closeFullScreenPopUp);
        };
        var renderButton = React__default.cloneElement(button, {
          key: key,
          onClick: onClick
        });
        return renderButton;
      });
      return renderButtons;
    }
  }, {
    key: "getPortal",
    value: function getPortal() {
      var _this$props3 = this.props,
        hideCloseOnFooter = _this$props3.hideCloseOnFooter,
        hideCloseOnHeader = _this$props3.hideCloseOnHeader,
        onForceOpenMessage = _this$props3.onForceOpenMessage;
      var _this$state = this.state,
        modalTitle = _this$state.modalTitle,
        modalContent = _this$state.modalContent,
        isDeepContent = _this$state.isDeepContent;
      var buttons = this.getButtonElements();
      var showFooter = !hideCloseOnFooter || buttons.length > 0;
      var contentSpaceBottom = showFooter ? '5rem' : '0';
      return /*#__PURE__*/React__default.createElement(ReactPortal, null, /*#__PURE__*/React__default.createElement("div", {
        className: "bf-fullscreen-popup-lib"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "fullscreen-popup",
        ref: this.modalContentRef
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "fullscreen-popup-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "fullscreen-popup-header"
      }, /*#__PURE__*/React__default.createElement("h3", {
        className: "fullscreen-popup-title margin-bottom-removed"
      }, modalTitle), !hideCloseOnHeader && /*#__PURE__*/React__default.createElement("div", {
        className: "fullscreen-popup-close"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "bf-icon-times",
        onClick: this.closePopUp
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "fullscreen-popup-content",
        style: {
          bottom: "".concat(contentSpaceBottom)
        }
      }, onForceOpenMessage ? /*#__PURE__*/React__default.createElement("div", {
        className: "force-open-message"
      }, onForceOpenMessage) : null, modalContent), showFooter ? /*#__PURE__*/React__default.createElement("div", {
        className: "fullscreen-popup-footer"
      }, !hideCloseOnFooter && /*#__PURE__*/React__default.createElement(Button, {
        secondary: true,
        onClick: this.closePopUp,
        className: "fullscreen-popup-close-button"
      }, /*#__PURE__*/React__default.createElement(FormattedMessage, {
        id: "bf.close",
        defaultMessage: "bf.close"
      })), isDeepContent ? /*#__PURE__*/React__default.createElement(Button, {
        primary: true,
        onClick: this.handleOnGoBack,
        className: "fullscreen-popup-close-button"
      }, /*#__PURE__*/React__default.createElement(FormattedMessage, {
        id: "bf.goBack",
        defaultMessage: "bf.goBack"
      })) : null, buttons.map(function (button) {
        return button;
      })) : null))));
    }
  }, {
    key: "setModalInformation",
    value: function setModalInformation(modalTitle, modalContent, isDeepContent) {
      this.setState({
        modalTitle: modalTitle,
        modalContent: modalContent,
        isDeepContent: isDeepContent
      });
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      var _this$modalContentRef;
      (_this$modalContentRef = this.modalContentRef.current) === null || _this$modalContentRef === void 0 ? void 0 : _this$modalContentRef.querySelector('.fullscreen-popup-content').scrollTo({
        top: 0
      });
    }
  }, {
    key: "handleOnGoBack",
    value: function handleOnGoBack() {
      var _this$props4 = this.props,
        title = _this$props4.title,
        content = _this$props4.content;
      this.setModalInformation(title, content, false);
      this.findDeepContent();
      this.scrollToTop();
    }
  }, {
    key: "findDeepContent",
    value: function findDeepContent() {
      var _this3 = this;
      var deepContent = this.props.deepContent;
      setTimeout(function () {
        deepContent.forEach(function (_ref) {
          var _this3$modalContentRe;
          var itemTitle = _ref.title,
            triggerClassName = _ref.triggerClassName,
            itemContent = _ref.content;
          var element = (_this3$modalContentRe = _this3.modalContentRef.current) === null || _this3$modalContentRe === void 0 ? void 0 : _this3$modalContentRe.querySelector(".".concat(triggerClassName));
          if (element) {
            element.onclick = function (e) {
              e.preventDefault();
              _this3.setModalInformation(itemTitle, itemContent, true);
              _this3.scrollToTop();
            };
            element.target = '_self';
          }
        });
      }, 0);
    }
  }, {
    key: "openPopUp",
    value: function openPopUp() {
      var onOpen = this.props.onOpen;
      this.setState({
        isActive: true
      });
      document.body.classList.add('full-screen-modal-open');
      if (typeof onOpen === 'function') {
        onOpen();
      }
    }
  }, {
    key: "closePopUp",
    value: function closePopUp() {
      var onClose = this.props.onClose;
      this.setState({
        isActive: false
      });
      document.body.classList.remove('full-screen-modal-open');
      if (typeof onClose === 'function') {
        onClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var trigger = this.props.trigger;
      var isActive = this.state.isActive;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, trigger ? this.getTriggerElement() : null, isActive ? this.getPortal() : null);
    }
  }]);
}(React__default.Component);
FullScreenPopUp.defaultProps = {
  trigger: null,
  title: '',
  buttons: [],
  hideCloseOnHeader: false,
  hideCloseOnFooter: false,
  forceOpen: false,
  onForceOpenMessage: null,
  onClose: null,
  onOpen: null,
  deepContent: []
};
FullScreenPopUp.propTypes = {
  trigger: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  buttons: PropTypes.arrayOf(PropTypes.object),
  hideCloseOnHeader: PropTypes.bool,
  hideCloseOnFooter: PropTypes.bool,
  forceOpen: PropTypes.bool,
  onForceOpenMessage: PropTypes.node,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  deepContent: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.element,
    triggerClassName: PropTypes.string
  }))
};

export { FullScreenPopUp as F };
//# sourceMappingURL=FullScreenPopUp-701c26eb.js.map
